import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tiktok-reply',
  templateUrl: './tiktok-reply.component.html',
  styleUrls: ['./tiktok-reply.component.css']
})
export class TiktokReplyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
